export const DISMISS_ERROR = 'DISMISS_ERROR';
export type DISMISS_ERROR = typeof DISMISS_ERROR;

export const ADD_ERROR = 'ADD_ERROR';
export type ADD_ERROR = typeof ADD_ERROR;
